import { h } from '../lib/dom.js';
import { getState, fmtReporting, toReporting } from '../store.js';
import { iconMarkup } from '../icons/index.js';
import { t } from '../i18n/index.js';
import { goActivityFromHome, toggleActivityInfo } from '../actions.js';

// Shared "Recent Activity" panel for the desktop two-column layouts
// (feature-ui.md's Desktop section). Home renders it always (mobile:
// stacked below Accounts, same as before; desktop: sticky right column —
// see .screen-rail-always in style.css); Receive/Send/Transfer render it
// desktop-only, since none of them showed a recent-activity list at all
// before this section. One row-rendering path either way, so the two
// call sites can't drift on what "recent" means or how a row is
// formatted — same reasoning as activity.js/home.js already sharing
// t('activity.sentTo'/'receivedFrom') for on-screen descriptions.
export function renderActivityRail(alwaysVisible) {
  const s = getState();
  const recentRows = s.transactions.slice(0, 6).map((txn) => {
    // txn.amount is an exact signed decimal string (AUDIT.md F2) --
    // Number() here is display formatting, not storage.
    const amountFmt = (Number(txn.amount) < 0 ? '-' : '+') + fmtReporting(Math.abs(toReporting(txn.ccy, txn.amount)));
    const desc = txn.type === 'out' ? t('activity.sentTo', { counterparty: txn.counterparty }) : t('activity.receivedFrom', { counterparty: txn.counterparty });
    return h('div', { class: 'tx-row clickable', onclick: () => goActivityFromHome(txn.id) }, [
      h('div', {}, [
        h('div', { class: 'desc' }, desc),
        h('div', { class: 'meta' }, txn.date)
      ]),
      h('span', { class: 'amount ' + (Number(txn.amount) > 0 ? 'positive' : 'negative') }, amountFmt)
    ]);
  });
  return h('div', { class: 'screen-rail' + (alwaysVisible ? ' screen-rail-always' : '') }, [
    h('div', { class: 'flex-gap-sm items-center' }, [
      h('div', { class: 'section-label' }, t('home.recentActivity')),
      h('button', { class: 'icon-btn-plain', 'aria-label': t('home.balanceInfoTitle'), onclick: toggleActivityInfo },
        h('span', { html: iconMarkup('circleQuestionMark', { size: 13, color: '#757993' }) }))
    ]),
    s.showActivityInfo ? h('div', { class: 'text-sm text-muted mb-sm' }, t('home.activityInfo')) : null,
    s.transactions.length
      ? h('div', { class: 'tx-list' }, recentRows)
      : h('div', { class: 'empty-state' }, t('home.noActivity'))
  ]);
}
